import { FileApi } from '../../test-api/index.ts'
const fileApi = new FileApi({}, '/api/v2')
import handleApiError from '../../utils/handleApiError'

export default async function ($store, $formValues, fileId) {
  const fileDetailResponse = await handleApiError(() => fileApi.fileDetail(fileId))
      
  $store.commit('nette/updateControl', {
    controlName: 'editFileForm',
    data: fileDetailResponse.data,
    key: 'detail',
  })

  $formValues['frm-editFileForm-editFileForm-name:change'] = fileDetailResponse.data.name
  $formValues['frm-editFileForm-editFileForm-original_name'] = fileDetailResponse.data.name
  $formValues['frm-editFileForm-editFileForm-id:change'] = fileDetailResponse.data.id
  $formValues['frm-editFileForm-editFileForm-tags:change'] = fileDetailResponse.data.tags

  $store.commit('nette/updateControl', {
    controlName: 'editFileForm',
    data: true,
    key: 'showModal',
  })
}